import React, { useContext, Suspense } from 'react';
import { Navigate, Outlet } from "react-router-dom";
import { UserContext } from '../contexts/UserContext';
import { UCMSProvider } from '../contexts/UCMSContext'
import { InfosProvider } from '../contexts/InfosContext'
import ErrorBoundary from '../components/ErrorBoundary'

function Authenticator() {
  const { token, loading } = useContext(UserContext);

  if (loading) {
    return <p>Carregando...</p>
  }

  if (!token) {
    return <Navigate to="/login" />
  }

  return (
    <UCMSProvider>
      <InfosProvider>
        <ErrorBoundary>
          <Suspense fallback={<p>Carregando...</p>}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </InfosProvider>
    </UCMSProvider>
  )
}

export default Authenticator